import { Select } from "@headlessui/react"
import { useSearch } from "@tanstack/react-router"
import React from "react"

import { usePartners } from "@/hooks"

interface Props {
  defaultDisabled?: boolean
  defaultOption?: string
  defaultValue?: string
  disabled?: boolean
  id: string
  name?: string
  onBlur?: (event: React.FocusEvent<HTMLSelectElement>) => void
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
  value?: string
}

const PartnerSelect: React.FC<Props> = ({
  defaultDisabled,
  defaultOption,
  defaultValue,
  disabled,
  id,
  name,
  onBlur,
  onChange,
  value,
}) => {
  const { partnerId } = useSearch({
    strict: false,
  })

  const { data: partners, isLoading, isError } = usePartners()

  if (isLoading) {
    return (
      <Select disabled>
        <option>Loading...</option>
      </Select>
    )
  }

  if (isError) {
    return (
      <Select disabled>
        <option>Error loading partners</option>
      </Select>
    )
  }

  return (
    <Select
      aria-label="Partner Name"
      className="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5"
      disabled={disabled}
      id={id}
      name={name ?? "partnerId"}
      onBlur={onBlur}
      onChange={onChange}
      value={(partnerId || value) ?? defaultValue}
    >
      {defaultOption && (
        <option value={defaultValue} disabled={defaultDisabled}>
          {defaultOption}
        </option>
      )}
      {partners
        ?.sort((a, b) => a.name.localeCompare(b.name))
        .map((partner, key) => (
          <option key={key} value={partner.id}>
            {partner.name}
          </option>
        ))}
    </Select>
  )
}

export default PartnerSelect
